export default __webpack_public_path__ + "static/hero-main-v2-yellow3-71b3e4d32fc81a30f92901914b8e3bb6.jpg";